import _ from 'lodash';
import { converter } from 'helpers/converter';

export const emailRegex = /^[A-Z0-9._%+\-&,´'\s]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

export const getFormErrors = (codeError, translations, errorsPlaceholder) => {
  const errorMsg = converter.convertApa(translations, codeError);

  const predicate = code => code === codeError;
  return _.flow(
    placeholders =>
      _.reduce(
        placeholders,
        (errors, placeholder, key) => ({
          ...errors,
          [key]: _.some(placeholder, predicate),
        }),
        {},
      ),
    _.pickBy,
    errors =>
      _.reduce(
        errors,
        (last, error, key) => ({
          ...last,
          [key]: { error, errorMsg, value: '' },
        }),
        {},
      ),
  )(errorsPlaceholder);
};
